import {i18n} from "@lingui/core";
import {en, ms, zh} from 'make-plural/plurals';
import antdEn from 'antd/lib/locale/en_US';
import antdZh from 'antd/lib/locale/zh_CN';
import antdMs from 'antd/lib/locale/ms_MY';

export const defaultLocale = 'en';

i18n.loadLocaleData({
    en: { plurals: en },
    ms: { plurals: ms },
    zh: { plurals: zh },
});

/**
* We do a dynamic import of just the catalog that we need
* @param locale any locale string
*/
export async function switchLanguage(locale) {
    const { messages } = await import(`./${locale}/messages`);
    i18n.load(locale, messages);
    i18n.activate(locale);
}

export const antdConfigs = {
    en: antdEn,
    ms: antdMs,
    zh: antdZh,
};

export const languageSwitcher = [
    { key: 'en', value: 'English', abbreviation: 'EN' },
    { key: 'ms', value: 'Bahasa Melayu', abbreviation: 'MY'},
    { key: 'zh', value: '中文', abbreviation: 'ZH' },
];
